import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import SmartBuildingFrontDeskList from './components/SmartBuildingFrontDeskList'


const { Cell } = ResponsiveGrid;

const SmartBuildingFrontDesk = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="智慧建築前台"
        breadcrumbs={[
          {
            name: '智慧建築專區',
          },
          {
            name: '智慧建築前台',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <SmartBuildingFrontDeskList />
    </Cell>
  </ResponsiveGrid>
);

export default SmartBuildingFrontDesk;
